import cn from 'classnames';
import {
  GroupHeadingProps,
  components as ReactSelectComponents,
  GroupBase,
  SelectComponentsConfig,
} from 'react-select';

import groupedStyles from '../groupedSelect.module.scss';

const handleHeaderClick = ({ selectProps, data }) => {
  const selected = selectProps.value
    ? [
      ...selectProps.value,
      ...data.options.filter((option) => !selectProps
        .value.find(
          (v) => selectProps.getOptionValue(option) === selectProps.getOptionValue(v),
        ),
      ),
    ]
    : data.options;

  selectProps.onChange(selected);
};

interface IProps<SOption, IsMulti extends boolean, Group extends GroupBase<SOption>> {
  dataTest: string,
  groupHeadingClassName?: string,
  onGroupHeaderClick?: (data: GroupHeadingProps<SOption, IsMulti, Group>) => void,
  components?: SelectComponentsConfig<SOption, IsMulti, Group>,
  ownProps: GroupHeadingProps<SOption, IsMulti, Group>,
}

const GroupHeading = <SOption, IsMulti extends boolean, Group extends GroupBase<SOption>>({
  dataTest,
  groupHeadingClassName,
  onGroupHeaderClick,
  components,
  ownProps,
}: IProps<SOption, IsMulti, Group>) => {
  const dataTestAttr = `${ dataTest }GroupHeading`;
  const onHeaderClick = onGroupHeaderClick || handleHeaderClick;

  if (components?.GroupHeading) {
    const { GroupHeading: GroupHeadingComponents } = components;

    return (
      <div data-test={ dataTestAttr } className={ groupHeadingClassName } onClick={ () => onHeaderClick(ownProps) }>
        <GroupHeadingComponents { ...ownProps } />
      </div>
    );
  }

  return (
    <div data-test={ dataTestAttr } onClick={ () => onHeaderClick(ownProps) }>
      <ReactSelectComponents.GroupHeading
        { ...ownProps }
        className={ cn(groupedStyles.groupHeader, groupHeadingClassName) }
      />
    </div>
  );
};

export default GroupHeading;
